import { AgGridColumnDef } from '@tassat/common-definitions';

export const ApiConnectionFirmsColumnDefs: AgGridColumnDef[] = [
    {
        field: 'firm.Name',
        headerName: 'Firm Name',
        sort: 'asc',
        menuTabs: ['filterMenuTab'],
        flex: 1
    },
    {
        field: 'firm.Email',
        headerName: 'Firm Email',
        menuTabs: ['filterMenuTab'],
        flex: 1
    },
    {
        field: 'apiFirm',
        headerName: 'Actions',
        maxWidth: 150,
        cellRenderer: 'actionButtonsCellRenderer',
        cellRendererParams: {
            actionButtonOptions: {
                hasDelete: false,
                hasLock: true
            }
        },
        menuTabs: [],
        flex: 1
    }
];